(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('AzioneDetailController', AzioneDetailController);

    AzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Azione'];

    function AzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Azione) {
        var vm = this;

        vm.azione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:azioneUpdate', function(event, result) {
            vm.azione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
